import { create } from 'zustand';

interface ErrorModalState {
  validationErrors: string[] | null;
  systemError: string | null;
  showValidation: (errors: string[]) => void;
  showSystem: (message?: string) => void;
  dismiss: () => void;
}

export const useErrorModalStore = create<ErrorModalState>()((set) => ({
  validationErrors: null,
  systemError: null,
  showValidation: (errors) => set({ validationErrors: errors, systemError: null }),
  showSystem: (message) =>
    set({
      systemError: message || 'An unexpected error occurred. Please try again later.',
      validationErrors: null,
    }),
  dismiss: () => set({ validationErrors: null, systemError: null }),
}));
